"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var react_tracking_1 = require("react-tracking");
var classNames = require("classnames");
var tracker_1 = require("../tracker");
var bind_1 = require("../bind");
var csrf_form_1 = require("../csrf_form");
var mparticle_tracker_1 = require("../elog/mparticle_tracker");
var COMPONENT_NAME = 'AddToCartButton';
function trackClick(props) {
    return {
        mParticleInteraction: {
            eventName: mparticle_tracker_1.MParticleEventName.AddToCart,
            productActionType: mparticle_tracker_1.ProductActionType.AddToCart,
            listing: props.listing,
            position: props.position,
            componentName: props.parentComponentName,
        },
        entityId: props.listing.id,
    };
}
var AddToCartButton = /** @class */ (function (_super) {
    tslib_1.__extends(AddToCartButton, _super);
    function AddToCartButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddToCartButton.prototype.handleClick = function (e) {
        e.stopPropagation();
    };
    Object.defineProperty(AddToCartButton.prototype, "listingId", {
        get: function () {
            return this.props.listing && this.props.listing.id || '';
        },
        enumerable: true,
        configurable: true
    });
    AddToCartButton.prototype.render = function () {
        var classes = classNames('add-to-cart-button', this.props.className);
        if (this.props.disabled) {
            return (React.createElement("div", { className: classes, "data-disabled": true }, I18n.t('commons.addToCart')));
        }
        return (React.createElement(csrf_form_1.default, { noValidate: true, id: "new_cart_item-" + this.listingId, action: "/cart", acceptCharset: "UTF-8", method: "post", key: this.listingId },
            React.createElement("input", { value: "web", type: "hidden", name: "cart_item[action_source_attributes][device]", id: "cart_item_action_source_attributes_device-" + this.listingId }),
            React.createElement("input", { value: this.listingId, type: "hidden", name: "cart_item[product_id]", id: "cart_item_product_id-" + this.listingId }),
            React.createElement("input", { type: "hidden", name: "_aid", id: "_aid-" + this.listingId, value: "hydra_featured_listing" }),
            React.createElement("input", { type: "hidden", name: "cart_item[quantity]", id: "cart_item[quantity]", value: this.props.quantity || 1 }),
            React.createElement("button", { type: "submit", className: classes, onClick: this.handleClick }, I18n.t('commons.addToCart'))));
    };
    tslib_1.__decorate([
        bind_1.default,
        react_tracking_1.default(trackClick)
    ], AddToCartButton.prototype, "handleClick", null);
    AddToCartButton = tslib_1.__decorate([
        react_tracking_1.default({
            componentName: COMPONENT_NAME,
            type: tracker_1.LISTING_TYPE,
        })
    ], AddToCartButton);
    return AddToCartButton;
}(React.Component));
exports.default = AddToCartButton;
//# sourceMappingURL=add_to_cart_button.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/add_to_cart_button.js
// module id = 2Uym
// module chunks = 0 1 2 3 4 6 8 11 12 13 20